var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnicornUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M478.939,174.89l16.235-7.793c4.97-2.386,6.288-8.819,2.619-12.934 c-12.74-14.289-42.434-43.693-84.976-61.926l12.219-8.146c5.567-3.712,4.699-12.161-1.543-14.571 c-38.065-14.696-145.34-42.933-225.573,64.044l250.89,198.071c25.585,20.199,63.19,1.975,63.19-30.622v-30.085 C512,207.952,478.939,174.89,478.939,174.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC4655"
    },
    d: "M487.204,268.502c-13.616-32.143-19.023-41.704-32.176-62.5 c-20.636-32.624-75.45-119.286-155.814-119.286c-10.396,0-20.942,1.47-31.345,4.37c-13.873,3.867-27.122,11.155-39.381,21.662 l-26.653,23.896c-0.004,0.003-0.003,0.007,0,0.01l236.428,170.481C470.674,331.931,499.86,298.38,487.204,268.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M6.439,10.182l174.95,197.769l57.857-66.122L10.896,4.82C7.437,2.744,3.766,7.161,6.439,10.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEBED"
    },
    d: "M508.74,367.249c-9.777-29.807-43.728-114.538-67.683-152.41 c-26.762-42.312-86.097-130.867-168.75-107.83c-11.54,3.216-22.63,9.348-33.061,18.289L4.462,335.794 c-3.308,2.966-5.089,7.459-4.26,11.823c1.914,10.084,7.814,14.771,14.066,16.817c2.724,0.891,4.967,2.77,6.239,5.337 c3.204,6.469,8.851,17.87,8.851,17.87c4.14,8.439,14.439,11.783,22.688,7.277c3.046-1.663,6.381-3.701,9.805-5.88l28.852,17.58 c4.944,2.995,11.038,3.215,16.161,0.539c24.73-12.909,100.81-50.758,157.178-58.696c11.754-1.656,22.677-4.792,32.789-8.956 l62.06,162.885c2.079,5.455,9.005,7.095,13.308,3.15l131.99-120.991C508.977,380.161,510.764,373.421,508.74,367.249z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBD9DC"
    },
    d: "M266.624,34.47v82.431c0,9.001,7.206,16.682,17.037,18.162l19.236,2.895 c13.163,1.981,24.966-7.86,23.693-19.855c-5.785-54.492-31.155-79.217-46.985-89.518C274.175,25.052,266.624,28.426,266.624,34.47z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBD9DC"
    },
    d: "M349.596,335.341c-3.21-5.733-2.642-12.767,1.286-18.034c4.397-5.895,8.154-12.198,11.156-18.873 c12.148-27.007,11.954-57.344-0.557-87.734c-1.735-4.221-6.546-6.231-10.792-4.496c-4.221,1.739-6.231,6.57-4.496,10.792 c10.743,26.079,11.01,51.896,0.767,74.658c-9.325,20.733-27.092,37.58-50.159,47.775l62.088,162.962 c2.079,5.456,9.005,7.095,13.309,3.15l48.045-44.041L349.596,335.341z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C969E"
    },
    d: "M37.435,350.7c-2.488-5.058-10.656-5.447-16.186,2.238c-2.7,3.752-5.069,7.289-12.551,8.717 c1.727,1.196,3.574,2.111,5.472,2.74c2.058,0.682,3.69,2.08,4.991,3.765C35.024,366.886,40.291,356.506,37.435,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0BCC1"
    },
    d: "M78.17,399.072c14.112-8.872,29.894-20.636,42.783-33.645c3.215-3.241,3.189-8.475-0.048-11.688 c-3.251-3.223-8.479-3.189-11.692,0.052c-14.293,14.42-34.067,26.698-47.531,35.353L78.17,399.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M239.246,224.583c-11.817,0-22.859-3.814-30.301-10.469c-3.406-3.043-3.697-8.265-0.662-11.671 c3.051-3.402,8.281-3.689,11.671-0.654c4.391,3.923,11.599,6.264,19.291,6.264s14.9-2.341,19.291-6.264 c3.39-3.035,8.62-2.748,11.671,0.654c3.035,3.406,2.744,8.629-0.662,11.671C262.104,220.769,251.062,224.583,239.246,224.583z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00C3FF"
    },
    points: "123.532,142.548 164.858,189.265 164.858,97.197 123.532,72.401 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4F582"
    },
    points: "82.205,95.831 123.532,142.548 123.532,72.401 82.205,47.605 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC850"
    },
    points: "40.879,49.114 82.205,95.831 82.205,47.605 40.879,22.809 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M40.879,22.809L10.896,4.82c-3.459-2.075-7.13,2.341-4.457,5.363l34.439,38.932V22.809H40.879z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicornUserIcon);
export default __webpack_public_path__ + "static/media/unicorn-user-icon.bb99c78133d84cf4d90decc71a513802.svg";
export { ForwardRef as ReactComponent };